import React from 'react';
import { motion } from 'framer-motion';

export const RiskMatrix = ({ data }) => {
  // En standard 5x5 risiko-matrise (Sannsynlighet x Konsekvens)
  const grid = Array(5).fill(null).map(() => Array(5).fill(null));
  
  const getCellColor = (x, y) => {
    const score = (x + 1) * (y + 1);
    if (score >= 15) return 'bg-rose-500';
    if (score >= 10) return 'bg-orange-400';
    if (score >= 5) return 'bg-amber-300';
    return 'bg-emerald-400';
  };

  return (
    <div className="space-y-4">
      <div className="flex">
        {/* Y-axis label */}
        <div className="flex flex-col justify-center pr-4">
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest vertical-text -rotate-180" style={{ writingMode: 'vertical-rl' }}>
            Konsekvens
          </p>
        </div>
        
        <div className="flex-1 space-y-1">
          <div className="grid grid-cols-5 gap-1 aspect-square md:aspect-video lg:aspect-square max-h-[400px]">
            {[4, 3, 2, 1, 0].map((y) => (
              <React.Fragment key={y}>
                {[0, 1, 2, 3, 4].map((x) => (
                  <div 
                    key={`${x}-${y}`} 
                    className={`rounded-lg ${getCellColor(x, y)} opacity-20 relative group hover:opacity-100 transition-opacity flex items-center justify-center`}
                  >
                    {/* Render dots for risks in this cell */}
                    {data.filter(r => r.x === x && r.y === y).map((risk, i) => (
                      <motion.div
                        key={i}
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        className="w-3 h-3 bg-slate-900 rounded-full border-2 border-white shadow-xl cursor-help"
                        title={risk.label}
                      />
                    ))}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
          {/* X-axis label */}
          <div className="text-center pt-4">
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Sannsynlighet</p>
          </div>
        </div>
      </div>
    </div>
  );
};